const getters = {
  isUserOwner: (state, getters, rootState) => state.owner && state.owner.id === rootState.user.id,
  columnSet: (state) => state.columnList.map((colId) => state.columns[colId]),
  cardSet: (state) => state.cards.map((card) => card.id).filter((card) => card !== undefined),
};

export default getters;
